import React from 'react';
import { Select, Divider, Input, Button } from 'antd';
import { connect } from 'react-redux';
import { requestServerPost, selectPage, requestNodeServerPost, requestServerGet } from '../actions';
import { PlusCircleFilled } from '@ant-design/icons';
import PopupManager from '../managers/PopupManager';
import StringHelper from '../helpers/StringHelper';

const { Option } = Select;

class PlaylistSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = { playlistDatas: [], playlistOptions: [], newPlaylistName: "" }
    }

    componentDidMount() {
        this.reloadPlaylists();
    }

    componentDidUpdate(prevProps) {
        if ("value" in this.props && this.props.value !== prevProps.value) {
            this.reloadPlaylists();
        }
    }

    reloadPlaylists = () => {

        const { usertoken, requestServerGet, brandid } = this.props;

        requestServerGet("get_playlists", { brandid: brandid }, null, (response) => {
            const options = response.data.map(data => {
                return { value: data.PlaylistID, label: data.PlaylistName }
            })

            // options.unshift({ value: 0, label: "Create New Playlist" })
            this.setState({ playlistDatas: response.data, playlistOptions: options })
        }, usertoken)
    }

    filter = (inputValue, path) => {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    }

    onChange = (value, selectedOptions) => {
        const { onChange } = this.props;
        onChange(value, selectedOptions);
    }

    onNameChange = event => {
        this.setState({
            newPlaylistName: event.target.value,
        });
    };

    render() {
        const { value, onSelect, onPlaylistCreated = () => { }, allowCreate = true } = this.props;
        var selectedPlaylistName = undefined
        if (this.state.playlistDatas) {
            const matchedPlaylist = this.state.playlistDatas.find(pl => {
                return pl.PlaylistID === value
            })

            if (matchedPlaylist)
                selectedPlaylistName = matchedPlaylist.PlaylistName
        }
        return (
            // <Cascader
            //     options={this.state.playlistOptions}
            //     onChange={this.onChange}
            //     placeholder="Select Playlist"
            //     showSearch={this.filter}
            // />


            <Select
                value={(value === -1) ? undefined : value}
                onSelect={onSelect}
                showSearch
                filterOption = {StringHelper.SELECT_SEARCH_FILTER_LABEL_OPTION}
                style={{ width: 300 }}
                placeholder="Select Playlist"
                dropdownRender={menu => (
                    <div>
                        {allowCreate ? ([<div style={{ display: 'flex', flexWrap: 'nowrap', padding: "4px" }} className="center-content">
                            {/* <Input style={{ flex: 'auto', height: "30px" }} value={this.state.newPlaylistName} onChange={this.onNameChange} /> */}

                            <Button size="medium" style={{ margin: "8px" }} onClick={() => {
                                PopupManager.launchCreatePlaylistPopup(onPlaylistCreated)
                            }} type="primary" icon={<PlusCircleFilled></PlusCircleFilled>}>New Playlist</Button>
                        </div>,
                        <Divider style={{ margin: '4px 0' }} />]) : null}

                        {menu}
                    </div>
                )}
            >
                {this.state.playlistOptions.sort((a,b) => StringHelper.SORT_NUM_STRING(a.label, b.label)).map(item => (
                    <Option key={item.value}>{item.label}</Option>
                ))}
            </Select>
        )
    }
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage, requestNodeServerPost })(PlaylistSelector);